import React, { useEffect, useState } from 'react';
import {
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Box
} from '@mui/material';
import CatchRights from '../../Models/Interfaces/CatchRights';
import { GetTransferPrice } from '../../Services/MillifaersluAPIService';
import { formatNumberWithThousandSeparator } from '../../Utils/numberFormat';

interface Props {
    selectedCatchRights: CatchRights[] | null;
}

const TransferTable: React.FC<Props> = ({ selectedCatchRights }) => {
    const [transferPrice, setTransferPrice] = useState<number | null>(null);

    useEffect(() => {
        const fetchTransferPrice = async () => {
            try {
                const response = await GetTransferPrice();
                setTransferPrice(response.price);
            } catch {
                setTransferPrice(null);
            }
        };

        fetchTransferPrice();
    }, []);

    return (
        <>
            <Typography variant="h6" color="primary" gutterBottom sx={{ marginTop: '20px', fontWeight: 'bold' }}>
                Millifærslur
            </Typography>

            <TableContainer component={Paper} elevation={0}>
                <Table aria-label="Yfirlit millifærslna" sx={{ minWidth: 540 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Fisktegund</TableCell>
                            <TableCell align="right">Magn</TableCell>
                            <TableCell align="right">Einingarverð</TableCell>
                            <TableCell align="right">Heildarverð</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selectedCatchRights?.map((right) => {
                            const unitPrice = right.kr ?? 0;
                            const totalPrice = right.quantity * unitPrice;

                            return (
                                <TableRow key={right.quotaType} hover>
                                    <TableCell component="th" scope="row" sx={{ fontWeight: 600 }}>
                                        {right.name}
                                    </TableCell>
                                    <TableCell align="right">
                                        {`${formatNumberWithThousandSeparator(right.quantity)} ${right.unit === 1 ? 'kg' : 'tonn'}`}
                                    </TableCell>
                                    <TableCell align="right">{formatNumberWithThousandSeparator(unitPrice)} kr</TableCell>
                                    <TableCell align="right">{formatNumberWithThousandSeparator(totalPrice)} kr</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            {transferPrice !== null && (
                <Box
                    sx={{
                        marginTop: 2,
                        padding: 2,
                        backgroundColor: 'background.default',
                        borderRadius: 1,
                        border: 1, borderColor: 'divider'
                    }}
                >
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                        Gjald fyrir rafræna millifærslu
                    </Typography>
                    <Typography variant="body1">
                        Verð á þessari rafrænu millifærslu er <strong>{formatNumberWithThousandSeparator(transferPrice)} kr.</strong>
                    </Typography>
                </Box>
            )}
        </>
    );
};

export default TransferTable;